import Dispatcher from "Dispatcher";
import DrawerLayout from "lib/common/drawer/DrawerLayout";
import { asMarionetteView } from "lib/common/hoc/BackboneReact/asMarionetteView";
import HexActions from "lib/hex/HexActions";
import ExportForms from "lib/hex/views/ExportForms";
import ResultsLayout from "./lib/resultslayout/ResultsLayout";
import ExportParamActions from "../../data/ExportParamActions";

const FormLayout = asMarionetteView(ExportForms);

class HarvestExportModule extends DrawerLayout {

    initialize(options){
        this.onRender = this.onRender.bind(this);
        this.onChangeResults = this.onChangeResults.bind(this);
        this.model = options.model;
        this.delegateEvents();
        this.fluxToken = Dispatcher.register(action => {
            if (action.type === HexActions.RERUN_EXPORT) {
                // The fact that we're in a dispatch is just a shitshow, but was
                // the option while double-crossing the Marionette boundary, so
                // just delay a tick and pretend it didn't happen.
                //
                // eslint-disable-next-line no-settimeout
                setTimeout(() => {
                    this.onDrawerOpen();
                    this._rerender({
                        key: action.typeKey,
                        params: action.params,
                    });
                });
            }
        });
    }

    onDrawerOpen(...args) {
        super.onDrawerOpen(...args);
        Dispatcher.dispatch({
            type: ExportParamActions.INVALIDATE_CACHE,
        });
    }

    onClose() {
        Dispatcher.unregister(this.fluxToken);
    }

    onRender(){
        this.onDrawerEnable();
        this.dispatch("get:harvest_history");
        this.onChangeResults(this.model);
        this._rerender();
    }

    _rerender(rerun) {
        this.drawer.show(new FormLayout({
            rerun,
        }));
    }

    onChangeResults(model){
        const collection = this.model.get("results");
        this.resultsLayout = new ResultsLayout({model: this.model, collection});
        this.content.show(this.resultsLayout);
        this.listenTo(this.resultsLayout, "get_harvest_history", () => {
            if (!this.open) {
                this.dispatch("get:harvest_history");
            }
        });

        if (typeof model.previous("results") !== "undefined") {
            this.onDrawerClose();
        }
    }

}

HarvestExportModule.prototype.modelEvents = {
    "change:results": "onChangeResults"
};

export default HarvestExportModule;



// WEBPACK FOOTER //
// ./app/lib/hex/HarvestExportModule.js